import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/faqs";

export default function FaqSection() {
  return (
    <section
      id="faq"
      data-testid="section-faq"
      className="bg-white py-20 lg:py-28"
    >
      <div className="container-pc">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <p className="eyebrow">Help & questions</p>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-navy tracking-tighter">
              Frequently asked questions
            </h2>
            <p className="mt-5 text-sm text-muted leading-relaxed">
              Couldn&rsquo;t find what you need? Our team replies within one working day.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="rounded-2xl border border-silver/60 bg-white divide-y divide-silver/60 overflow-hidden"
              data-testid="faq-accordion"
            >
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={item.q}
                  value={`item-${i}`}
                  className="border-b-0"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="px-5 py-5 text-left text-[15px] font-semibold text-navy hover:no-underline hover:bg-ice/60 [&[data-state=open]]:bg-ice/40 transition-colors">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="px-5 pb-5 pt-0 text-sm text-ink/75 leading-[1.75]">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
